import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { refreshAllIpRanges, refreshIpRange, type TIpRangeRefresh } from '../../entities/ip-range';

export interface IRefreshRanges {
  run: (key?: string) => void;
  busy: string | null;
  outcomes: TIpRangeRefresh[] | null;
  error: unknown;
  dismiss: () => void;
}

// Outcomes are held in state, not read off `mutation.data`: three different results all leave the table unchanged.
export const useRefreshRanges = (): IRefreshRanges => {
  const client = useQueryClient();
  const [outcomes, setOutcomes] = useState<TIpRangeRefresh[] | null>(null);
  const [busy, setBusy] = useState<string | null>(null);

  const mutation = useMutation({
    mutationFn: (key?: string) => (key ? refreshIpRange(key) : refreshAllIpRanges()),
    onSuccess: (data) => {
      setOutcomes(data);
      void client.invalidateQueries({ queryKey: ['ip-ranges'] });
    },
    onSettled: () => setBusy(null),
  });

  return {
    run: (key?: string) => {
      setBusy(key ?? '*');
      setOutcomes(null);
      mutation.mutate(key);
    },
    busy: mutation.isPending ? busy : null,
    outcomes,
    error: mutation.error,
    dismiss: () => setOutcomes(null),
  };
};
